import api from '@app/api'

import type { ResponseDto } from '@app/api/dtos'
import type {
  GetExternalProductsSearchProductsListParams,
  GetExternalProductsListParams,
  PatchExternalProductsListItemData,
  GetDependentProductsParams,
  GetExternalProductsSearchListParams,
  ChangeExternalProductsLinkData,
  PostExternalProductsLinkData,
  DeleteExternalProductsUnlinkData
} from './types'
import type {
  ExternalProductsListDto,
  ExternalProductsListItemDto,
  DependetProductDto,
  ExternalProductsSearchListItemDto
} from './dtos'

const URL = '/external-products/'

export const getExternalProductsList = async (
  params?: GetExternalProductsListParams
): Promise<ResponseDto<ExternalProductsListDto>> => {
  const response = await api.get<ResponseDto<ExternalProductsListDto>>(URL, { params })
  return response.data
}

export const getExternalProductsListItem = async (id: string): Promise<ExternalProductsListItemDto> => {
  const url = `${URL}${id}/`

  const response = await api.get<ExternalProductsListItemDto>(url)
  return response.data
}

export const patchExternalProductsListItem = async ({
  id,
  ...data
}: PatchExternalProductsListItemData): Promise<void> => {
  const url = `${URL}${id}/`

  const response = await api.patch(url, data)
  return response.data
}

export const getDependentProducts = async ({
  id,
  ...params
}: GetDependentProductsParams): Promise<ResponseDto<DependetProductDto>> => {
  const url = `${URL}${id}/dependent/`

  const response = await api.get<ResponseDto<DependetProductDto>>(url, { params })
  return response.data
}

export const getExternalProductsSearchList = async (
  params?: GetExternalProductsSearchListParams
): Promise<ResponseDto<ExternalProductsSearchListItemDto>> => {
  const url = `${URL}search/`

  const response = await api.get<ResponseDto<ExternalProductsSearchListItemDto>>(url, { params })
  return response.data
}

export const getExternalProductsSearchProductsList = async (
  params?: GetExternalProductsSearchProductsListParams
): Promise<ResponseDto<ExternalProductsSearchListItemDto>> => {
  const url = `${URL}search/products/`

  const response = await api.get<ResponseDto<ExternalProductsSearchListItemDto>>(url, { params })
  return response.data
}

export const patchExternalProductsProductLink = async ({
  id,
  productId
}: ChangeExternalProductsLinkData): Promise<void> => {
  const url = `${URL}${id}/product-link/${productId}/`

  const response = await api.patch(url)
  return response.data
}

export const postExternalProductsLink = async (data: PostExternalProductsLinkData): Promise<void> => {
  const url = `${URL}link/`

  const response = await api.post(url, data)
  return response.data
}

export const deleteExternalProductsLink = async ({ id, productId }: ChangeExternalProductsLinkData): Promise<void> => {
  const url = `${URL}${id}/product-link/${productId}/`

  await api.delete(url)
}

export const deleteExternalProductsUnlink = async ({ id }: DeleteExternalProductsUnlinkData): Promise<void> => {
  const url = `${URL}${id}/unlink/`

  await api.delete(url)
}
